const scriptSrc = window.customElements ? '/card.min.js' : '/card-polyfilled.min.js';
window.cardComponentLoaded = new Promise(function (resolve) {
	const cardJs = document.createElement('script');
	cardJs.crossOrigin = 'anonymous';
	cardJs.src = 'https://p.trellocdn.com' + scriptSrc;
	cardJs.onload = resolve;
	document.head.appendChild(cardJs);
});